import ImagemLogo from './../../../../../assets/images/logo-lateral.png';
import ImagemLogoGovfacil from './../../../../../assets/images/logo-govfacil-white.png';
import ImageWaves from './../../../../../assets/images/waves.png';
import { IGiveawayAuto } from '../../../../../interfaces';
import { convertDataUSParaBrasilEHora, poeValorComPontosEmMil } from '../../../../../utils/Conversores';
import { IStatsGiveawayAuto } from '../../useViewGiveawayAuto';
import { ITicketDistribution } from '../../../../../services/http/services/TicketsService';
import ChartTicketsDistribution from './ChartTicketsDistribution';
import { calculateVariation } from '../../../../../utils/Functions';
import { urlHttpGov } from '../../../../../services/urls';
import { useContext } from 'react';
import { ThemeContext } from '../../../../../contexts/ThemeContext';
import Title from 'antd/es/typography/Title';
import Text from 'antd/es/typography/Text';
import { Card, Col, Divider, Row } from 'antd';
import { CardItem } from '../CardItem';
import { WinnersCard } from '../WinnersCard';

interface IProps {
    giveawayAutoData: IGiveawayAuto | undefined;
    previousGiveawayAutoData: IGiveawayAuto | null | undefined;
    statsGiveawayAuto: IStatsGiveawayAuto;
    statsPreviousGiveawayAuto: IStatsGiveawayAuto;
    ticketDistribution: ITicketDistribution[] | undefined;
    canViewWinners: boolean;
    refToPrint: any;
    onChartAnimationEnd: () => void
}


export default function ReportStatsGiveawayAuto({ onChartAnimationEnd, giveawayAutoData, previousGiveawayAutoData, statsGiveawayAuto, statsPreviousGiveawayAuto, canViewWinners, ticketDistribution, refToPrint }: IProps) {

    const DISTRIBUTION_COLORS = ['#00C49F', '#0088FE', '#FFBB28', '#FF8042', '#F99999'];

    const { theme } = useContext(ThemeContext);

    function renderVariationSpan(previous: number | null | undefined, current: number | null | undefined) {
        if (previous === 0) {
            return <Text style={{
                textAlign: 'center',
                marginTop: 8,
                fontSize: 20,
                fontWeight: 700,
                color: '#969393ff',
            }}>0%</Text>;
        }

        const variation = calculateVariation(previous, current);

        return (
            <Text style={{
                textAlign: 'center',
                marginTop: 8,
                fontSize: 20,
                fontWeight: 700,
                color: variation > 0 ? '#15803d' : '#b91c1c',
            }}>
                {variation > 0 ? '+' : null}{variation.toFixed(2)}%
            </Text>
        );
    }




    return (
        <div ref={refToPrint} className="report-content"
        >
            <Row className="header-report" justify={'space-between'} style={{ display: 'none' }}>
                <Col className="header-info">
                    <h1>Relatório do {giveawayAutoData?.description}</h1>
                    <p>{giveawayAutoData?.city?.city} - {giveawayAutoData?.city?.uf}</p>
                </Col>

                <Col className="header-logo">
                    <img
                        src={giveawayAutoData?.city?.logo_county ? `${urlHttpGov}/logo_county/${giveawayAutoData?.city?.logo_county}` : ImagemLogo}
                        alt="Logo município"
                    />
                </Col>
            </Row>


            <div className="footer-report" style={{ display: 'none' }}>
                <img
                    width={'180px'}
                    src={ImagemLogo}
                    alt="Logo do Sistema"
                    className="logo-img footer-report-logo-img"
                />
                <div className="footer-report-date-generated">
                    <p>
                        Arquivo gerado em {new Date().toLocaleDateString("pt-BR")} às {new Date().toLocaleTimeString("pt-BR", {
                            hour: "2-digit",
                            minute: "2-digit"
                        })}
                    </p>
                </div>
                <img
                    width={'200px'}
                    style={{
                        position: 'absolute',
                        bottom: 0,
                        right: 0,
                        marginBottom: '50px',
                        marginRight: '15mm',
                        padding: '15px',
                    }}
                    src={ImagemLogoGovfacil}
                    alt="Logo do Sistema"
                    className="logo-img"
                />
                <img className="footer-report-img" alt='Imagem rodapé' src={ImageWaves} width="100%" />
            </div>

            <div className="page">
                <div className="line-divider" />
                <Card
                    className='section-report report-card'
                    style={{
                        borderRadius: 12,
                        padding: 0,
                        marginBottom: 20,
                        boxShadow: '0 3px 8px rgba(0, 0, 0, 0.08)',
                    }}>


                    <Title level={5} className="section-title" style={{ fontWeight: "normal" }}>Identificação do Sorteio</Title>
                    <Row gutter={12} align="middle">
                        <Col flex={2}>
                            <CardItem label='Período de participação' theme={theme} value={`${convertDataUSParaBrasilEHora(giveawayAutoData?.period_beginning)} - ${convertDataUSParaBrasilEHora(giveawayAutoData?.period_ending)}`} />
                        </Col>
                        <Col span={6}>
                            <Card bodyStyle={{ padding: 12 }} className='info-item' style={{
                                borderRadius: 8,
                                padding: 0,
                                background: theme === "light" ? "#f8f9fa" : "#222",
                            }}>
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <Text className='section-label' type='secondary' style={{ fontSize: 12, marginBottom: 4 }}>Data do sorteio:</Text>
                                    <Text className='section-text' style={{ fontWeight: 'bold' }}>{convertDataUSParaBrasilEHora(giveawayAutoData?.date)}</Text>
                                </div>
                            </Card>
                        </Col>
                        <Col span={6}>
                            <Card bodyStyle={{ padding: 12 }} className='info-item' style={{
                                borderRadius: 8,
                                padding: 0,
                                background: theme === "light" ? "#f8f9fa" : "#222",
                            }}>
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <Text className='section-label' type='secondary' style={{ fontSize: 12, marginBottom: 4 }}>Status:</Text>
                                    <Text className="section-text color-green" style={{ fontWeight: 'bold' }}>{giveawayAutoData?.status}</Text>
                                </div>
                            </Card>
                        </Col>
                    </Row>
                </Card>
                <Card
                    className='section-report report-card'
                    style={{
                        borderRadius: 12,
                        padding: 0,
                        marginBottom: 20,
                        boxShadow: '0 3px 8px rgba(0, 0, 0, 0.08)',
                    }}>
                    <Title level={5} className="section-title" style={{ fontWeight: "normal" }}>Estatísticas de Participação</Title>
                    <Row gutter={[12, 12]} align="middle">
                        <Col span={8}>
                            <Card className='info-item' bodyStyle={{ padding: 12 }} style={{
                                borderRadius: 8,
                                padding: 0,
                                background: theme === "light" ? "#f8f9fa" : "#222",
                            }}>
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <Text className='section-label' type='secondary' style={{ fontSize: 12, marginBottom: 4 }}>Usuários participantes</Text>
                                    <Text style={{
                                        fontSize: '1.25rem',
                                        fontWeight: 800,
                                        lineHeight: 1,
                                        letterSpacing: '-0.02em',
                                        whiteSpace: 'nowrap',
                                        color: '#1c6dd0'
                                    }}>{poeValorComPontosEmMil(statsGiveawayAuto?.total_participants)}</Text>
                                </div>
                            </Card>
                        </Col>
                        <Col span={8}>
                            <Card className='info-item' bodyStyle={{ padding: 12 }} style={{
                                borderRadius: 8,
                                padding: 0,
                                background: theme === "light" ? "#f8f9fa" : "#222",
                            }}>
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <Text className='section-label' type='secondary' style={{ fontSize: 12, marginBottom: 4 }}>Impostos importados</Text>
                                    <Text style={{
                                        fontSize: '1.25rem',
                                        fontWeight: 800,
                                        lineHeight: 1,
                                        letterSpacing: '-0.02em',
                                        whiteSpace: 'nowrap',
                                        color: '#15803d'
                                    }}>{poeValorComPontosEmMil(statsGiveawayAuto?.total_taxes)}</Text>
                                </div>
                            </Card>
                        </Col>
                        <Col span={8}>
                            <Card className='info-item' bodyStyle={{ padding: 12 }} style={{
                                borderRadius: 8,
                                padding: 0,
                                background: theme === "light" ? "#f8f9fa" : "#222",
                            }}>
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <Text className='section-label' type='secondary' style={{ fontSize: 12, marginBottom: 4 }}>Bilhetes gerados</Text>
                                    <Text style={{
                                        fontSize: '1.25rem',
                                        fontWeight: 800,
                                        lineHeight: 1,
                                        letterSpacing: '-0.02em',
                                        whiteSpace: 'nowrap',
                                        color: '#1c6dd0'
                                    }}>{poeValorComPontosEmMil(statsGiveawayAuto?.total_tickets)}</Text>
                                </div>
                            </Card>
                        </Col>
                    </Row>
                </Card>

                <Card
                    className='section-report report-card'
                    style={{
                        borderRadius: 12,
                        padding: 0,
                        marginBottom: 20,
                        boxShadow: '0 3px 8px rgba(0, 0, 0, 0.08)',
                    }}>
                    <Title level={5} className="section-title" style={{ fontWeight: "normal" }}>Estatísticas de Distribuição dos Bilhetes</Title>

                    <Row gutter={16}>

                        <Col span={12}>

                            {ticketDistribution?.map((distribution, index) => {
                                return (<Card
                                    className='card-distribution'
                                    key={index}
                                    size="small"
                                    style={{
                                        borderRight: `5px solid ${DISTRIBUTION_COLORS[index]}`,
                                        borderRadius: 8,
                                        padding: 8,
                                        marginBottom: 8,
                                    }}
                                    bodyStyle={{ padding: 0 }}
                                ><div style={{ display: "flex", flexDirection: "row", justifyContent: 'space-between' }}>
                                        <Text className='section-label' style={{ fontSize: 12, margin: 0, display: "block" }}>
                                            {distribution.range}
                                        </Text>
                                        <Text
                                            strong
                                            style={{
                                                fontSize: 12,
                                                margin: 0,
                                                color: DISTRIBUTION_COLORS[index],
                                                display: "block",
                                            }}
                                        >
                                            {distribution.users} usuários ({distribution.users_percentage}%)
                                        </Text>
                                    </div>
                                </Card>)
                            })}
                        </Col>

                        <Col span={10}>
                            {ticketDistribution && <ChartTicketsDistribution onAnimationEnd={onChartAnimationEnd} colors={DISTRIBUTION_COLORS} data={ticketDistribution} />}

                        </Col>


                    </Row>

                </Card>
            </div>
            <div className='page'>
                <div className="line-divider" />
                {giveawayAutoData && previousGiveawayAutoData && <Card
                    className='section-report report-card'
                    style={{
                        borderRadius: 12,
                        padding: 0,
                        marginBottom: 20,
                        boxShadow: '0 3px 8px rgba(0, 0, 0, 0.08)',
                    }}>
                    <Title level={5} className="section-title" style={{ fontWeight: "normal" }}>Comparativo com Sorteio Anterior</Title>

                    <Row gutter={12} align='middle'>
                        <Col span={8}>
                            <Card className='info-item' bodyStyle={{ padding: 12 }} style={{
                                borderRadius: 8,
                                padding: 0,
                                background: theme === "light" ? "#f8f9fa" : "#222",
                            }}>
                                <Text className='section-label' type='secondary' style={{ fontSize: 12, marginBottom: 4 }}>Participantes</Text>
                                <Row style={{ display: "flex", flexDirection: "column", }}>

                                    <Row style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        fontSize: 14,
                                        marginBottom: 2,
                                    }}>
                                        <Text className='section-label' style={{ fontSize: 12, marginTop: 6, margin: 0 }}>Anterior:</Text>
                                        <Text style={{
                                            fontWeight: 700,
                                            fontSize: 12,
                                            color: '#1c6dd0',
                                            display: 'inline-block',
                                            textAlign: 'center',
                                            maxWidth: 'fit-content',
                                        }}>{poeValorComPontosEmMil(previousGiveawayAutoData.total_user_participating!)}</Text>
                                    </Row>
                                    <Row style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        fontSize: 14,
                                        marginBottom: 2,
                                    }}>
                                        <Text className='section-label' style={{ fontSize: 12, margin: 0 }}>Atual:</Text>
                                        <Text style={{
                                            fontWeight: 700,
                                            fontSize: 12,
                                            color: '#1c6dd0',
                                            display: 'inline-block',
                                            textAlign: 'center',
                                            maxWidth: 'fit-content',
                                        }}>{poeValorComPontosEmMil(giveawayAutoData.total_user_participating!)}</Text>
                                    </Row>
                                    <Divider style={{ margin: 4 }} />
                                    {renderVariationSpan(previousGiveawayAutoData.total_user_participating, giveawayAutoData.total_user_participating)}
                                </Row>
                            </Card>
                        </Col>
                        <Col span={8}>
                            <Card className='info-item' bodyStyle={{ padding: 12 }} style={{
                                borderRadius: 8,
                                padding: 0,
                                background: theme === "light" ? "#f8f9fa" : "#222",
                            }}>

                                <Text className='section-label' type='secondary' style={{ fontSize: 12, marginBottom: 4 }}>Quantidade de bilhetes</Text>
                                <Row style={{ display: "flex", flexDirection: "column" }}>
                                    <Row style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        fontSize: 14,
                                        marginBottom: 2,
                                    }}>
                                        <Text className='section-label' style={{ fontSize: 12, marginTop: 6, margin: 0 }}>Anterior:</Text>
                                        <Text style={{
                                            fontWeight: 700,
                                            fontSize: 12,
                                            color: '#6b21a8',
                                            display: 'inline-block',
                                            textAlign: 'center',
                                            maxWidth: 'fit-content',
                                        }}>{poeValorComPontosEmMil(previousGiveawayAutoData.total_tickets!)}</Text >
                                    </Row>
                                    <Row style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        fontSize: 14,
                                        marginBottom: 2,
                                    }}>
                                        <Text className='section-label' style={{ fontSize: 12, margin: 0 }}>Atual:</Text>
                                        <Text style={{
                                            fontWeight: 700,
                                            fontSize: 12,
                                            color: '#6b21a8',
                                            display: 'inline-block',
                                            textAlign: 'center',
                                            maxWidth: 'fit-content',
                                        }}>{poeValorComPontosEmMil(giveawayAutoData.total_tickets!)}</Text>
                                    </Row>
                                    <Divider style={{ margin: 4 }} />
                                    {renderVariationSpan(previousGiveawayAutoData.total_tickets, giveawayAutoData.total_tickets)}
                                </Row>
                            </Card>
                        </Col>
                    </Row>


                </Card>}
                <Card
                    className='section-report report-card'
                    style={{
                        borderRadius: 12,
                        padding: 0,
                        marginBottom: 20,
                        boxShadow: '0 3px 8px rgba(0, 0, 0, 0.08)',
                    }}>
                    <Title level={5} className="section-title" style={{ fontWeight: "normal" }}>Prêmios {canViewWinners && 'e Ganhadores'}</Title>
                    <WinnersCard canViewWinners={canViewWinners} giveawayAutoData={giveawayAutoData} />
                </Card>
            </div>
        </div>
    );
}
